
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/faceblur",
      function () {
        return require("private-next-pages/demo/faceblur.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/faceblur"])
      });
    }
  